// extracted by mini-css-extract-plugin
export default {"tooltip":"aS-z","arrow":"bS-z"};